module.exports = __webpack_public_path__ + "img/1F1FA-1F1F3.1ce737d5.svg";